import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0b209d10"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "permission-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { setPermissionStatusApi } from '@/service/modules/role';
export default /*#__PURE__*/_defineComponent({
  __name: 'permission-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editRoleItem: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: 'addSubset'
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['closeDialog', 'resData'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const subBtnLoading = ref(false);
    const formRef = ref();
    const form = reactive({
      id: null,
      parent_name: '',
      parent_id: null,
      e_name: '',
      title: '',
      type: 1,
      icon: '',
      component: '',
      redirect: '',
      is_show: 1,
      display_order: 0
    });
    const rules = {
      parent_id: [{
        required: true,
        message: '请输入父级菜单',
        trigger: 'blur'
      }],
      e_name: [{
        required: true,
        message: '请输入唯一标识',
        trigger: 'blur'
      }],
      title: [{
        required: true,
        message: '请输入菜单名称',
        trigger: 'blur'
      }],
      icon: [{
        required: true,
        message: '请输入图标',
        trigger: 'blur'
      }],
      type: [{
        required: true,
        message: '请选择菜单类型',
        trigger: 'change'
      }],
      is_show: [{
        required: true,
        message: '请选择是否显示',
        trigger: 'change'
      }]
    };
    function restForm() {
      form.id = null;
      form.e_name = '';
      form.display_order = '';
      form.parent_id = null;
      form.parent_name = '';
      form.title = '';
      form.type = 1;
      form.icon = '';
      form.component = '';
      form.redirect = '';
      form.is_show = 1;
      formRef.value?.resetFields();
    }
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning('正在保存，请稍后~~');
      restForm();
      emit('closeDialog');
    }
    function handleDialog(type) {
      if (!type) {
        closeDialog();
      }
      formRef.value?.validate(valid => {
        if (valid) {
          // ElMessage.success('校验通过')
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      let params = {};
      params = JSON.parse(JSON.stringify(form));
      if (props.dialogType === 'add') {
        delete params.id;
        delete params.parent_id;
        delete params.parent_name;
      } else if (props.dialogType === 'edit') {
        delete params.parent_id;
        delete params.parent_name;
      } else if (props.dialogType === 'addSubset') {
        delete params.id;
        delete params.parent_name;
      }
      try {
        let res = await setPermissionStatusApi(params);
        ElMessage.success(props.dialogType === 'add' ? '添加成功' : '编辑成功');
        restForm();
        emit('resData');
      } catch {} finally {
        subBtnLoading.value = false;
      }
    }
    const title = computed(() => {
      if (props.dialogType === 'add') {
        return '添加权限';
      } else if (props.dialogType === 'edit' || props.dialogType === 'addSubset') {
        return '编辑权限';
      }
    });
    watch(() => props.dialogVisible, newValue => {
      if (newValue) {
        nextTick(() => {
          formRef.value?.resetFields();
          if (props.dialogType == 'edit') {
            for (let key in form) {
              form[key] = props.itemData[key];
            }
          }
          if (props.dialogType == 'addSubset') {
            form.parent_id = props.itemData.id;
            form.parent_name = props.itemData.title;
          }
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "35%",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => handleDialog(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: subBtnLoading.value,
          onClick: _cache[10] || (_cache[10] = $event => handleDialog(true))
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [props.dialogType === 'addSubset' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "上级菜单",
            prop: "parent_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.parent_name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.parent_name = $event),
              placeholder: "请输入父级菜单",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "唯一标识",
            prop: "e_name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.e_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.e_name = $event),
              placeholder: "请输入唯一标识"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "菜单名称",
            prop: "title"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.title,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.title = $event),
              placeholder: "请输入菜单名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "菜单类型",
            prop: "type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.type,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.type = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("菜单")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => [_createTextVNode("路由")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "图标",
            prop: "icon"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.icon,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.icon = $event),
              placeholder: "请输入图标"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "component"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.component,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.component = $event),
              placeholder: "请输入组件地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), form.type === 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "redirect"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.redirect,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.redirect = $event),
              placeholder: "请输入重定向路径"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "排序"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.display_order,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.display_order = $event),
              placeholder: "请输入排序"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否显示",
            prop: "is_show"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.is_show,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.is_show = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("是")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 0
              }, {
                default: _withCtx(() => [_createTextVNode("否")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});